import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  initialize(){
    super.initialize();
    this.filter = document.querySelector('[data-controller="admin--index-filter"]');

    if(this.filter){
      this.filterTriggerer = this.filter.querySelector('[data-admin--index-filter-target="filterTriggerer"]');
    }
  }

  connect(){
    super.connect();
    this.bindChangeDateFilter();
    this.bindFilter();
  }

  bindFilter(){
    if(!this.filterTriggerer) return;
    this.filterTriggerer.addEventListener('click', (e) => {
      window.KTApp.blockPage();
      const params = [];
      const checkboxValues = {};

      const inputs = this.filter.querySelectorAll('input,select');
      for(let i=0 ;i<inputs.length; i++){
        if(inputs[i].type === 'radio'){
          if(inputs[i].checked){
            params.push({
              name: inputs[i].name,
              value: inputs[i].value
            });
          }
        } else if(inputs[i].tagName === 'SELECT'){
          if(inputs[i].hasAttribute('multiple')){
            const selectedValues = Array.prototype.slice.call(
              inputs[i].selectedOptions
            ).map((x) => {return x.value});
            params.push({
              name: inputs[i].name,
              value: selectedValues
            });
          } else {
            const selectedOption = inputs[i].selectedOptions[0]
            if(selectedOption){
              params.push({
                name: inputs[i].name,
                value: selectedOption.value
              });
            }
          }
        } else if(inputs[i].type === 'checkbox'){
          // Collect checkbox values by name
          if(!checkboxValues[inputs[i].name]){
            checkboxValues[inputs[i].name] = [];
          }
          if(inputs[i].checked){
            checkboxValues[inputs[i].name].push(inputs[i].value);
          }
        } else {
          params.push({
            name: inputs[i].name,
            value: inputs[i].value
          });
        }
      }

      // Process checkbox values - set param only if there are checked values, otherwise clear it
      Object.keys(checkboxValues).forEach((name) => {
        if(checkboxValues[name].length > 0){
          params.push({
            name: name,
            value: checkboxValues[name]
          });
        } else {
          // Clear the param if no checkboxes are checked
          this.datatable.setDataSourceParam(name, null);
        }
      });

      if(params.length > 0){
        params.forEach((entry) => {
          this.datatable.setDataSourceParam(entry.name, entry.value);
        });
      }
      this.datatable.load();

      window.KTApp.unblockPage();
      this.filter.click();
    });
  }

  bindChangeDateFilter(){
    $('#kt_dashboard_daterangepicker_custom').on('apply.daterangepicker', function(e, picker) {
      this.datatable.setDataSourceParam('daterange', `${picker.startDate.format("DD/MM/YYYY")}-${picker.endDate.format("DD/MM/YYYY")}`);
      this.datatable.load();
    }.bind(this));
  }

  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'id',
        title: 'id',
        overflow: 'visible',
        autoHide: false,
        sortable: false,
        template: function(data) {
          return `
            <span data-controller="base--popover" data-base--popover-html="1" data-base--popover-trigger="hover" data-content="${data.id}" data-title="Id" class="svg-icon svg-icon-light-dark" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="0" y="0" width="24" height="24"/>
                      <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                      <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                      <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                  </g>
              </svg>
            </span>
            <span class="font-weight-bolder">${data.id.slice(-6)}</span>
            `;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal',
        autoHide: false,
        width: 100,
        template: function(data) {
          return `
            <span data-controller="base--popover" data-base--popover-html="1" data-base--popover-trigger="hover" data-content="Dibuat: ${data.created_at} <br/> Diubah: ${data.updated_at}" data-title="Dibuat/Diubah" class="svg-icon svg-icon-light-dark" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="0" y="0" width="24" height="24"/>
                      <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                      <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                      <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                  </g>
              </svg>
            </span>
            <span class="font-weight-bolder">${data.created_at}</span>
            `;
        }
      },
      {
        field: 'price_cents',
        title: 'Nominal',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.price}</span>`;
        }
      },
      {
        field: 'status',
        title: 'Status',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          let file = '';
          if (data.receipt_path) {
            file = `
              <a href="${data.receipt_path}" target="_blank">
                <i class="fas fa-external-link-alt"></i>
              </a>
            `;
          }

          return `
            <span class="font-weight-bolder">
              ${data.status_html}
            </span>
            ${file}
          `;
        }
      },
      {
        field: 'payout_expiration_timestamp',
        title: 'Payout Expiration',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">
            ${data.payout_expiration_at || '-'}
          </span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Actions',
        sortable: false,
        width: 120,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Tampilkan">
              <i class="fa fa-eye text-primary"></i>
            </a>
          `;
        },
      }
    ]
  }
}
